import {
  ApiRequest,
  ApiResponse,
  fetchDataFromAPITyped,
} from './api-requests';
import { UserAttributes } from '../models/login-register-model';

export type EmailOtpRequestResponse = {
  message?: string;
  ttlSeconds?: number;
};

export type EmailOtpConfirmResponse = {
  message?: string;
  email_verified?: boolean;
};

export type SelfPromoteHostResponse = {
  message?: string;
  user?: UserAttributes;
  alreadyHost?: boolean;
};

export const requestEmailOtp = async (): Promise<
  ApiResponse<EmailOtpRequestResponse | null>
> => {
  const apiQuery: ApiRequest = {
    route: 'user/email/request-otp',
    request: {
      method: 'POST',
      entity: 'user',
      body: {},
    },
  };
  return await fetchDataFromAPITyped<EmailOtpRequestResponse>(apiQuery);
};

export const confirmEmailOtp = async (
  code: string
): Promise<ApiResponse<EmailOtpConfirmResponse | null>> => {
  const apiQuery: ApiRequest = {
    route: 'user/email/confirm-otp',
    request: {
      method: 'POST',
      entity: 'user',
      body: { code },
    },
  };
  return await fetchDataFromAPITyped<EmailOtpConfirmResponse>(apiQuery);
};

export const selfPromoteToHost = async (
  captchaToken: string
): Promise<ApiResponse<SelfPromoteHostResponse | null>> => {
  const apiQuery: ApiRequest = {
    route: 'user/self-promote-host',
    request: {
      method: 'POST',
      entity: 'user',
      body: { captchaToken },
    },
  };
  return await fetchDataFromAPITyped<SelfPromoteHostResponse>(apiQuery);
};
